import React, { forwardRef } from 'react';
import type { ForwardedRef } from 'react';

import { LIVENESS_OPTIONS } from '@vlabs/api-bindings/src/luna-client/constants';
import { ControllableOptionsFilter } from '@vlabs/monokit/shared/ui/options-filter';
import type { FilterPopoverProps } from '@vlabs/monokit/shared/ui/popovers/filter-popover';
import { FilterPopover } from '@vlabs/monokit/shared/ui/popovers/filter-popover';
import { useFormContext } from 'react-hook-form';

import st from '../popovers.module.sass';

function LivenessFilterPopover(
  {
    name = 'liveness',
    ...props
  }: FilterPopoverProps<string>,
  ref: ForwardedRef<HTMLDivElement>,
): React.JSX.Element {
  const { control } = useFormContext();

  return (
    <FilterPopover
      {...props}
      name={name}
      ref={ref}
    >
      <ControllableOptionsFilter
        control={control}
        isSearchable={false}
        name={name}
        options={LIVENESS_OPTIONS.raw}
      />
      <div className={st.Divider} />
    </FilterPopover>
  );
}

const LivenessFilterPopoverWithRef = forwardRef(LivenessFilterPopover);
export { LivenessFilterPopoverWithRef as LivenessFilterPopover };
